import LoadingBar from 'components/LoadingBar'

import s from './LoadingState.module.css'

export const LoadingState = () => {
  return (
    <div className={s.wrapper}>
      {Array.from({ length: 6 }).map((_, index) => (
        <div className={s.card} key={index}>
          <div className={s.header}>
            <LoadingBar borderRadius={4} width={60} />
            <LoadingBar borderRadius={4} width={60} />
          </div>
          <LoadingBar borderRadius={4} width={200} />
          <LoadingBar borderRadius={4} />
          <LoadingBar borderRadius={4} />
        </div>
      ))}
    </div>
  )
}
